import { Colors } from '@sigma-frontend-libs/commons'

import { buttonModes, icons, sizes } from '@/utils'

import button from '@/components/button'
import squircle from '@/components/icon/squircle'
import urlShortenerPreset from '@/components/rules/actions/urlShortenerPreset'
import mccmnc from '@/components/rules/conditions/mccmnc'
import { baseClass, ruleIcons, ruleTags } from '@/components/rules/utils'
import tag from '@/components/tag'

function renderLabel(h) {
  return h(
    'div',
    {
      class: `${baseClass}-item__holder-label`
    },
    [ this.getTranslate(`${baseClass}.tags.${this.tag}`) ]
  )
}

function renderTag(h, item, trigger = true) {
  if (trigger) {
    return h(
      tag,
      {
        props: {
          label: item.label || item,
          color: item.color || Colors.primary,
          size: sizes.small
        }
      }
    )
  }
}
function renderTags(h) {
  return this.$_value.map(item => {
    return renderTag.call(this, h, item)
  })
}
function renderTagsArray(h) {
  return [
    renderTags.call(this, h),
    renderTag.call(this, h, {
      label: `+${this.value.length - this.maxTags}`,
      color: Colors.black
    }, this.value.length - this.maxTags > 0)
  ]
}

function renderValueByTag(h) {
  switch (this.tag) {
    case ruleTags.mccmnc: {
      return h(
        mccmnc,
        {
          props: {
            value: this.value,
            count: this.maxTags
          }
        }
      )
    }
    case ruleTags.urlShortenerPresetId: {
      return h(
        urlShortenerPreset,
        {
          props: { value: this.value }
        }
      )
    }
    default: {
      if (Array.isArray(this.$_value) && this.$_value.length) {
        return renderTagsArray.call(this, h)
      }

      return renderTag.call(this, h, this.$_value)
    }
  }
}

function renderValue(h) {
  if (this.hasValue) {
    return h(
      'div',
      {
        class: `${baseClass}-item__holder-value`
      },
      [ renderValueByTag.call(this, h) ]
    )
  }

  return renderLabel.call(this, h)
}

function renderIcon(h) {
  return h(
    squircle,
    {
      props: {
        icon: ruleIcons[this.tag],
        color: Colors.grey,
        size: sizes.medium,
        tooltip: this.getTranslate(`${baseClass}.tags.${this.tag}`)
      }
    }
  )
}

function renderItemHolder(h) {
  if (this.tag) {
    return h(
      'div',
      {
        class: {
          [`${baseClass}-item__holder`]: true,
          [`${baseClass}-item__holder--empty`]: !this.hasValue
        },
        on: {
          click: () => {
            this.$emit('dialog', true)
          }
        }
      },
      [ renderValue.call(this, h) ]
    )
  }
}

function renderClearButton(h) {
  if (this.clearable) {
    return h(
      button,
      {
        class: { 'hover-child': this.viewport.breakpoint.mdUp },
        props: {
          icon: icons.clear,
          mode: buttonModes.flat,
          disabled: !this.hasValue || this.readonly
        },
        on: {
          click: () => {
            this.$emit('clear', true)
          }
        }
      }
    )
  }
}

export default function(h) {
  return h(
    'div',
    {
      class: {
        [`${baseClass}-item hover-parent hover-parent--opacity`]: true,
        [`${baseClass}-item--clearable`]: this.clearable
      }
    },
    [
      renderIcon.call(this, h),
      renderItemHolder.call(this, h),
      renderClearButton.call(this, h)
    ]
  )
}
